import ngFocusIf from 'ng-focus-if';
import { InputContainer } from 'components/inputContainer/inputContainer';

import template from './orderNotes.html';
import './orderNotes.scss';

export const OrderNotes = angular
    .module('checkout.components.orderSummary.orderNotes', [
        ngFocusIf,
        InputContainer
    ]).component('orderNotes', {
        template,
        bindings: {
            orderNotes: '<',
            onOrderNotesChanged: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/orderNotes/orderNotes.js